import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import '@uplatform-ai/fe-utils/fontawesome7'

import '@/assets/css/main.css'

import 'dayjs/locale/en'
import 'dayjs/locale/ru'
import { installVuePlugins } from '#/vue-plugins'
import { createApp } from 'vue'

import App from './App.vue'
import { appPluginsOrder, getTenantConfig } from './config/app'
import { APP_CONFIG_KEY, applyTheme, useTenant } from './shared/lib/tenant'

/*
|--------------------------------------------------------------------------
| Fix conflict NaiveUI and Tailwind's Preflight Style
|--------------------------------------------------------------------------
*/

const meta = document.createElement('meta')
meta.name = 'naive-ui-style'
document.head.appendChild(meta)

async function startApp() {
  const { tenantId } = useTenant()
  const config = getTenantConfig(tenantId)
  applyTheme(config.theme)

  const app = createApp(App)
  app.config.globalProperties.$appConfig = config
  app.provide(APP_CONFIG_KEY, config)

  await installVuePlugins(app, appPluginsOrder)

  app.mount('#app')
}

startApp()
